var GrupoActions;
(function (GrupoActions) {
    GrupoActions["DELETE_GRUPO"] = "DeleteGrupo";
    GrupoActions["DELETE_RANGE_GRUPO"] = "DeleteRangeGrupo";
    GrupoActions["FILTER_GRUPO"] = "FilterGrupo";
    GrupoActions["GET_GRUPO"] = "GetGrupo";
    GrupoActions["GETWITHDISABLED_GRUPO"] = "GetWithDisabledGrupo";
    GrupoActions["GET_BY_ID_GRUPO"] = "GetByIdGrupo";
    GrupoActions["POST_GRUPO"] = "PostGrupo";
    GrupoActions["PUT_GRUPO"] = "PutGrupo";
    GrupoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaGrupo";
    GrupoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaGrupo";
})(GrupoActions || (GrupoActions = {}));
var Grupo_SetorActions;
(function (Grupo_SetorActions) {
    Grupo_SetorActions["DELETE_GRUPO_SETOR"] = "DeleteGrupo_Setor";
    Grupo_SetorActions["DELETE_RANGE_GRUPO_SETOR"] = "DeleteRangeGrupo_Setor";
    Grupo_SetorActions["FILTER_GRUPO_SETOR"] = "FilterGrupo_Setor";
    Grupo_SetorActions["GET_GRUPO_SETOR"] = "GetGrupo_Setor";
    Grupo_SetorActions["GETWITHDISABLED_GRUPO_SETOR"] = "GetWithDisabledGrupo_Setor";
    Grupo_SetorActions["GET_BY_ID_GRUPO_SETOR"] = "GetByIdGrupo_Setor";
    Grupo_SetorActions["POST_GRUPO_SETOR"] = "PostGrupo_Setor";
    Grupo_SetorActions["PUT_GRUPO_SETOR"] = "PutGrupo_Setor";
    Grupo_SetorActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaGrupo_Setor";
    Grupo_SetorActions["UPLOAD_PLANILHA"] = "UploadPlanilhaGrupo_Setor";
    Grupo_SetorActions["POSTRANGE_GRUPO_SETOR"] = "PostRangeGrupo_Setor";
    Grupo_SetorActions["POSTRANGE_USUARIO_ETAPA_CHAMADO"] = "PostRange_Usuario_Etapa_Chamado";
})(Grupo_SetorActions || (Grupo_SetorActions = {}));
var Grupo_Setor_UsuarioActions;
(function (Grupo_Setor_UsuarioActions) {
    Grupo_Setor_UsuarioActions["DELETE_GRUPO_SETOR_USUARIO"] = "DeleteGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["DELETE_RANGE_GRUPO_SETOR_USUARIO"] = "DeleteRangeGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["FILTER_GRUPO_SETOR_USUARIO"] = "FilterGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["GET_GRUPO_SETOR_USUARIO"] = "GetGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["GETWITHDISABLED_GRUPO_SETOR_USUARIO"] = "GetWithDisabledGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["GET_BY_ID_GRUPO_SETOR_USUARIO"] = "GetByIdGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["POST_GRUPO_SETOR_USUARIO"] = "PostGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["PUT_GRUPO_SETOR_USUARIO"] = "PutGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaGrupo_Setor_Usuario";
    Grupo_Setor_UsuarioActions["UPLOAD_PLANILHA"] = "UploadPlanilhaGrupo_Setor_Usuario";
})(Grupo_Setor_UsuarioActions || (Grupo_Setor_UsuarioActions = {}));
var SetorActions;
(function (SetorActions) {
    SetorActions["DELETE_SETOR"] = "DeleteSetor";
    SetorActions["DELETE_RANGE_SETOR"] = "DeleteRangeSetor";
    SetorActions["FILTER_SETOR"] = "FilterSetor";
    SetorActions["GET_SETOR"] = "GetSetor";
    SetorActions["GETWITHDISABLED_SETOR"] = "GetWithDisabledSetor";
    SetorActions["GET_BY_ID_SETOR"] = "GetByIdSetor";
    SetorActions["POST_SETOR"] = "PostSetor";
    SetorActions["PUT_SETOR"] = "PutSetor";
    SetorActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaSetor";
    SetorActions["UPLOAD_PLANILHA"] = "UploadPlanilhaSetor";
})(SetorActions || (SetorActions = {}));
var CampoActions;
(function (CampoActions) {
    CampoActions["DELETE_CAMPO"] = "DeleteCampo";
    CampoActions["DELETE_RANGE_CAMPO"] = "DeleteRangeCampo";
    CampoActions["FILTER_CAMPO"] = "FilterCampo";
    CampoActions["GET_CAMPO"] = "GetCampo";
    CampoActions["GETWITHDISABLED_CAMPO"] = "GetWithDisabledCampo";
    CampoActions["GET_BY_ID_CAMPO"] = "GetByIdCampo";
    CampoActions["POST_CAMPO"] = "PostCampo";
    CampoActions["PUT_CAMPO"] = "PutCampo";
    CampoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaCampo";
    CampoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaCampo";
})(CampoActions || (CampoActions = {}));
var Campo_Etapa_ChamadoActions;
(function (Campo_Etapa_ChamadoActions) {
    Campo_Etapa_ChamadoActions["DELETE_CAMPO_ETAPA_CHAMADO"] = "DeleteCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["DELETE_RANGE_CAMPO_ETAPA_CHAMADO"] = "DeleteRangeCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["FILTER_CAMPO_ETAPA_CHAMADO"] = "FilterCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["GET_CAMPO_ETAPA_CHAMADO"] = "GetCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["GETWITHDISABLED_CAMPO_ETAPA_CHAMADO"] = "GetWithDisabledCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["GET_BY_ID_CAMPO_ETAPA_CHAMADO"] = "GetByIdCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["POST_CAMPO_ETAPA_CHAMADO"] = "PostCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["PUT_CAMPO_ETAPA_CHAMADO"] = "PutCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaCampo_Etapa_Chamado";
    Campo_Etapa_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaCampo_Etapa_Chamado";
})(Campo_Etapa_ChamadoActions || (Campo_Etapa_ChamadoActions = {}));
var ChamadoActions;
(function (ChamadoActions) {
    ChamadoActions["DELETE_CHAMADO"] = "DeleteChamado";
    ChamadoActions["DELETE_RANGE_CHAMADO"] = "DeleteRangeChamado";
    ChamadoActions["FILTER_CHAMADO"] = "FilterChamado";
    ChamadoActions["GET_CHAMADO"] = "GetChamado";
    ChamadoActions["GETWITHDISABLED_CHAMADO"] = "GetWithDisabledChamado";
    ChamadoActions["GET_BY_ID_CHAMADO"] = "GetByIdChamado";
    ChamadoActions["POST_CHAMADO"] = "PostChamado";
    ChamadoActions["PUT_CHAMADO"] = "PutChamado";
    ChamadoActions["CHANGE_STATUS_CHAMADO"] = "ChangeStatusChamado";
    ChamadoActions["CHANGE_ETAPA_CHAMADO"] = "ChangeEtapaChamado";
    ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaChamado";
    ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaChamado";
    ChamadoActions["GET_CHAMADO_BY_CODE"] = "GetChamadoByCode";
    ChamadoActions["UPLOAD_IMAGE"] = "UploadImageChamado";
    ChamadoActions["UPLOAD_FILE"] = "UploadFileChamado";
    ChamadoActions["UPLOAD_VIDEO"] = "UploadVideoChamado";
})(ChamadoActions || (ChamadoActions = {}));
var Etapa_ChamadoActions;
(function (Etapa_ChamadoActions) {
    Etapa_ChamadoActions["DELETE_ETAPA_CHAMADO"] = "DeleteEtapa_Chamado";
    Etapa_ChamadoActions["DELETE_RANGE_ETAPA_CHAMADO"] = "DeleteRangeEtapa_Chamado";
    Etapa_ChamadoActions["FILTER_ETAPA_CHAMADO"] = "FilterEtapa_Chamado";
    Etapa_ChamadoActions["GET_ETAPA_CHAMADO"] = "GetEtapa_Chamado";
    Etapa_ChamadoActions["GETWITHDISABLED_ETAPA_CHAMADO"] = "GetWithDisabledEtapa_Chamado";
    Etapa_ChamadoActions["GET_BY_ID_ETAPA_CHAMADO"] = "GetByIdEtapa_Chamado";
    Etapa_ChamadoActions["GET_ETAPA_BY_TEMPLATE_ID"] = "GetEtapaByTemplateId";
    Etapa_ChamadoActions["POST_ETAPA_CHAMADO"] = "PostEtapa_Chamado";
    Etapa_ChamadoActions["PUT_ETAPA_CHAMADO"] = "PutEtapa_Chamado";
    Etapa_ChamadoActions["ATUALIZAR_ORDEM_ETAPAS"] = "AtualizarOrdemEtapas";
    Etapa_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaEtapa_Chamado";
    Etapa_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaEtapa_Chamado";
})(Etapa_ChamadoActions || (Etapa_ChamadoActions = {}));
var IteracaoActions;
(function (IteracaoActions) {
    IteracaoActions["DELETE_ITERACAO"] = "DeleteIteracao";
    IteracaoActions["DELETE_RANGE_ITERACAO"] = "DeleteRangeIteracao";
    IteracaoActions["FILTER_ITERACAO"] = "FilterIteracao";
    IteracaoActions["GET_ITERACAO"] = "GetIteracao";
    IteracaoActions["GETWITHDISABLED_ITERACAO"] = "GetWithDisabledIteracao";
    IteracaoActions["GET_BY_ID_ITERACAO"] = "GetByIdIteracao";
    IteracaoActions["POST_ITERACAO"] = "PostIteracao";
    IteracaoActions["PUT_ITERACAO"] = "PutIteracao";
    IteracaoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaIteracao";
    IteracaoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaIteracao";
})(IteracaoActions || (IteracaoActions = {}));
var Responsavel_ChamadoActions;
(function (Responsavel_ChamadoActions) {
    Responsavel_ChamadoActions["DELETE_RESPONSAVEL_CHAMADO"] = "DeleteResponsavel_Chamado";
    Responsavel_ChamadoActions["DELETE_RANGE_RESPONSAVEL_CHAMADO"] = "DeleteRangeResponsavel_Chamado";
    Responsavel_ChamadoActions["FILTER_RESPONSAVEL_CHAMADO"] = "FilterResponsavel_Chamado";
    Responsavel_ChamadoActions["GET_RESPONSAVEL_CHAMADO"] = "GetResponsavel_Chamado";
    Responsavel_ChamadoActions["GETWITHDISABLED_RESPONSAVEL_CHAMADO"] = "GetWithDisabledResponsavel_Chamado";
    Responsavel_ChamadoActions["GET_BY_ID_RESPONSAVEL_CHAMADO"] = "GetByIdResponsavel_Chamado";
    Responsavel_ChamadoActions["POST_RESPONSAVEL_CHAMADO"] = "PostResponsavel_Chamado";
    Responsavel_ChamadoActions["POST_RANGE_RESPONSAVEL_CHAMADO"] = "PostRangeResponsavel_Chamado";
    Responsavel_ChamadoActions["PUT_RESPONSAVEL_CHAMADO"] = "PutResponsavel_Chamado";
    Responsavel_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaResponsavel_Chamado";
    Responsavel_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaResponsavel_Chamado";
})(Responsavel_ChamadoActions || (Responsavel_ChamadoActions = {}));
var SLAActions;
(function (SLAActions) {
    SLAActions["DELETE_SLA"] = "DeleteSLA";
    SLAActions["DELETE_RANGE_SLA"] = "DeleteRangeSLA";
    SLAActions["FILTER_SLA"] = "FilterSLA";
    SLAActions["GET_SLA"] = "GetSLA";
    SLAActions["GETWITHDISABLED_SLA"] = "GetWithDisabledSLA";
    SLAActions["GET_BY_ID_SLA"] = "GetByIdSLA";
    SLAActions["POST_SLA"] = "PostSLA";
    SLAActions["PUT_SLA"] = "PutSLA";
    SLAActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaSLA";
    SLAActions["UPLOAD_PLANILHA"] = "UploadPlanilhaSLA";
})(SLAActions || (SLAActions = {}));
var Status_ChamadoActions;
(function (Status_ChamadoActions) {
    Status_ChamadoActions["DELETE_STATUS_CHAMADO"] = "DeleteStatus_Chamado";
    Status_ChamadoActions["DELETE_RANGE_STATUS_CHAMADO"] = "DeleteRangeStatus_Chamado";
    Status_ChamadoActions["FILTER_STATUS_CHAMADO"] = "FilterStatus_Chamado";
    Status_ChamadoActions["GET_STATUS_CHAMADO"] = "GetStatus_Chamado";
    Status_ChamadoActions["GETWITHDISABLED_STATUS_CHAMADO"] = "GetWithDisabledStatus_Chamado";
    Status_ChamadoActions["GET_BY_ID_STATUS_CHAMADO"] = "GetByIdStatus_Chamado";
    Status_ChamadoActions["POST_STATUS_CHAMADO"] = "PostStatus_Chamado";
    Status_ChamadoActions["PUT_STATUS_CHAMADO"] = "PutStatus_Chamado";
    Status_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaStatus_Chamado";
    Status_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaStatus_Chamado";
})(Status_ChamadoActions || (Status_ChamadoActions = {}));
var Template_ChamadoActions;
(function (Template_ChamadoActions) {
    Template_ChamadoActions["DELETE_TEMPLATE_CHAMADO"] = "DeleteTemplate_Chamado";
    Template_ChamadoActions["DELETE_RANGE_TEMPLATE_CHAMADO"] = "DeleteRangeTemplate_Chamado";
    Template_ChamadoActions["FILTER_TEMPLATE_CHAMADO"] = "FilterTemplate_Chamado";
    Template_ChamadoActions["GET_TEMPLATE_CHAMADO"] = "GetTemplate_Chamado";
    Template_ChamadoActions["GET_TEMPLATE_CHAMADO_BY_TIPO"] = "GetTemplate_Chamado_ByTipo";
    Template_ChamadoActions["GETWITHDISABLED_TEMPLATE_CHAMADO"] = "GetWithDisabledTemplate_Chamado";
    Template_ChamadoActions["GET_BY_ID_TEMPLATE_CHAMADO"] = "GetByIdTemplate_Chamado";
    Template_ChamadoActions["POST_TEMPLATE_CHAMADO"] = "PostTemplate_Chamado";
    Template_ChamadoActions["PUT_TEMPLATE_CHAMADO"] = "PutTemplate_Chamado";
    Template_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTemplate_Chamado";
    Template_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTemplate_Chamado";
})(Template_ChamadoActions || (Template_ChamadoActions = {}));
var Tipo_CampoActions;
(function (Tipo_CampoActions) {
    Tipo_CampoActions["DELETE_TIPO_CAMPO"] = "DeleteTipo_Campo";
    Tipo_CampoActions["DELETE_RANGE_TIPO_CAMPO"] = "DeleteRangeTipo_Campo";
    Tipo_CampoActions["FILTER_TIPO_CAMPO"] = "FilterTipo_Campo";
    Tipo_CampoActions["GET_TIPO_CAMPO"] = "GetTipo_Campo";
    Tipo_CampoActions["GETWITHDISABLED_TIPO_CAMPO"] = "GetWithDisabledTipo_Campo";
    Tipo_CampoActions["GET_BY_ID_TIPO_CAMPO"] = "GetByIdTipo_Campo";
    Tipo_CampoActions["POST_TIPO_CAMPO"] = "PostTipo_Campo";
    Tipo_CampoActions["PUT_TIPO_CAMPO"] = "PutTipo_Campo";
    Tipo_CampoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTipo_Campo";
    Tipo_CampoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTipo_Campo";
})(Tipo_CampoActions || (Tipo_CampoActions = {}));
var Tipo_ChamadoActions;
(function (Tipo_ChamadoActions) {
    Tipo_ChamadoActions["DELETE_TIPO_CHAMADO"] = "DeleteTipo_Chamado";
    Tipo_ChamadoActions["DELETE_RANGE_TIPO_CHAMADO"] = "DeleteRangeTipo_Chamado";
    Tipo_ChamadoActions["FILTER_TIPO_CHAMADO"] = "FilterTipo_Chamado";
    Tipo_ChamadoActions["GETWITHDISABLED_TIPO_CHAMADO"] = "GetWithDisabledTipo_Chamado";
    Tipo_ChamadoActions["GET_TIPO_CHAMADO"] = "GetTipo_Chamado";
    Tipo_ChamadoActions["GET_TIPOS_CHAMADO"] = "GetTiposChamado_Chamado";
    Tipo_ChamadoActions["GET_BY_ID_TIPO_CHAMADO"] = "GetByIdTipo_Chamado";
    Tipo_ChamadoActions["POST_TIPO_CHAMADO"] = "PostTipo_Chamado";
    Tipo_ChamadoActions["PUT_TIPO_CHAMADO"] = "PutTipo_Chamado";
    Tipo_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaTipo_Chamado";
    Tipo_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaTipo_Chamado";
})(Tipo_ChamadoActions || (Tipo_ChamadoActions = {}));
var Valor_CampoActions;
(function (Valor_CampoActions) {
    Valor_CampoActions["DELETE_VALOR_CAMPO"] = "DeleteValor_Campo";
    Valor_CampoActions["DELETE_RANGE_VALOR_CAMPO"] = "DeleteRangeValor_Campo";
    Valor_CampoActions["FILTER_VALOR_CAMPO"] = "FilterValor_Campo";
    Valor_CampoActions["GET_VALOR_CAMPO"] = "GetValor_Campo";
    Valor_CampoActions["GETWITHDISABLED_VALOR_CAMPO"] = "GetWithDisabledValor_Campo";
    Valor_CampoActions["GET_BY_ID_VALOR_CAMPO"] = "GetByIdValor_Campo";
    Valor_CampoActions["POST_VALOR_CAMPO"] = "PostValor_Campo";
    Valor_CampoActions["PUT_VALOR_CAMPO"] = "PutValor_Campo";
    Valor_CampoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaValor_Campo";
    Valor_CampoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaValor_Campo";
})(Valor_CampoActions || (Valor_CampoActions = {}));
var Grupo_Setor_Etapa_ChamadoActions;
(function (Grupo_Setor_Etapa_ChamadoActions) {
    Grupo_Setor_Etapa_ChamadoActions["DELETE_GRUPO_SETOR_ETAPA_CHAMADO"] = "DeleteGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["DELETE_RANGE_GRUPO_SETOR_ETAPA_CHAMADO"] = "DeleteRangeGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["FILTER_GRUPO_SETOR_ETAPA_CHAMADO"] = "FilterGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["GET_GRUPO_SETOR_ETAPA_CHAMADO"] = "GetGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["GETWITHDISABLED_GRUPO_SETOR_ETAPA_CHAMADO"] = "GetWithDisabledGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["GET_BY_ID_GRUPO_SETOR_ETAPA_CHAMADO"] = "GetByIdGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["POST_GRUPO_SETOR_ETAPA_CHAMADO"] = "PostGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["PUT_GRUPO_SETOR_ETAPA_CHAMADO"] = "PutGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaGrupo_Setor_Etapa_Chamado";
    Grupo_Setor_Etapa_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaGrupo_Setor_Etapa_Chamado";
})(Grupo_Setor_Etapa_ChamadoActions || (Grupo_Setor_Etapa_ChamadoActions = {}));
var Grupo_Setor_Projeto_ClienteActions;
(function (Grupo_Setor_Projeto_ClienteActions) {
    Grupo_Setor_Projeto_ClienteActions["DELETE_GRUPO_SETOR_PROJETO_CLIENTE"] = "DeleteGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["DELETE_RANGE_GRUPO_SETOR_PROJETO_CLIENTE"] = "DeleteRangeGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["FILTER_GRUPO_SETOR_PROJETO_CLIENTE"] = "FilterGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["GET_GRUPO_SETOR_PROJETO_CLIENTE"] = "GetGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["GETWITHDISABLED_GRUPO_SETOR_PROJETO_CLIENTE"] = "GetWithDisabledGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["GET_BY_ID_GRUPO_SETOR_PROJETO_CLIENTE"] = "GetByIdGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["POST_GRUPO_SETOR_PROJETO_CLIENTE"] = "PostGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["PUT_GRUPO_SETOR_PROJETO_CLIENTE"] = "PutGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaGrupo_Setor_Projeto_Cliente";
    Grupo_Setor_Projeto_ClienteActions["UPLOAD_PLANILHA"] = "UploadPlanilhaGrupo_Setor_Projeto_Cliente";
})(Grupo_Setor_Projeto_ClienteActions || (Grupo_Setor_Projeto_ClienteActions = {}));
var Seguidor_ChamadoActions;
(function (Seguidor_ChamadoActions) {
    Seguidor_ChamadoActions["DELETE_SEGUIDOR_CHAMADO"] = "DeleteSeguidor_Chamado";
    Seguidor_ChamadoActions["DELETE_RANGE_SEGUIDOR_CHAMADO"] = "DeleteRangeSeguidor_Chamado";
    Seguidor_ChamadoActions["FILTER_SEGUIDOR_CHAMADO"] = "FilterSeguidor_Chamado";
    Seguidor_ChamadoActions["GET_SEGUIDOR_CHAMADO"] = "GetSeguidor_Chamado";
    Seguidor_ChamadoActions["GETWITHDISABLED_SEGUIDOR_CHAMADO"] = "GetWithDisabledSeguidor_Chamado";
    Seguidor_ChamadoActions["GET_BY_ID_SEGUIDOR_CHAMADO"] = "GetByIdSeguidor_Chamado";
    Seguidor_ChamadoActions["POST_SEGUIDOR_CHAMADO"] = "PostSeguidor_Chamado";
    Seguidor_ChamadoActions["PUT_SEGUIDOR_CHAMADO"] = "PutSeguidor_Chamado";
    Seguidor_ChamadoActions["TOGGLE_SEGUIDOR_CHAMADO"] = "ToggleSeguidorChamado";
    Seguidor_ChamadoActions["DOWNLOAD_PLANILHA"] = "DownloadPlanilhaSeguidor_Chamado";
    Seguidor_ChamadoActions["UPLOAD_PLANILHA"] = "UploadPlanilhaSeguidor_Chamado";
})(Seguidor_ChamadoActions || (Seguidor_ChamadoActions = {}));
export { GrupoActions, Grupo_SetorActions, Grupo_Setor_UsuarioActions, SetorActions, CampoActions, Campo_Etapa_ChamadoActions, ChamadoActions, Etapa_ChamadoActions, IteracaoActions, Responsavel_ChamadoActions, SLAActions, Status_ChamadoActions, Template_ChamadoActions, Tipo_CampoActions, Tipo_ChamadoActions, Valor_CampoActions, Grupo_Setor_Etapa_ChamadoActions, Grupo_Setor_Projeto_ClienteActions, Seguidor_ChamadoActions, };
//# sourceMappingURL=chmEnums.js.map